export const BASE_URI = process.env.REACT_APP_API_BASE_URL;

export const GET_WAITING_ROOMS_PATH = '/api/get-waiting-rooms';
export const GET_WAITING_ROOM_PATH = '/api/get-waiting-room';
export const GET_WAITING_ROOMS_REQUEST_NAME = 'GET_WAITING_ROOMS_REQUEST';

export const UPSERT_WAITING_ROOM_PATH = '/api/upsert-waiting-room';
export const UPSERT_WAITING_ROOM_REQUEST_NAME = 'UPSERT_WAITING_ROOM_REQUEST';

export const DELETE_WAITIM_ROOM_PATH = '/api/delete-waiting-room';
export const DELETE_WAITING_ROOM_REQUEST_NAME = 'DELETE_WAITING_ROOM_REQUEST';

export const START_WAITING_ROOM_PATH = '/api/start-waiting-room';
export const START_WAITING_ROOM_REQUEST_NAME = 'START_WAITING_ROOM_REQUEST';

export const STOP_WAITING_ROOM_PATH = '/api/stop-waiting-room';
export const STOP_WAITING_ROOM_REQUEST_NAME = 'STOP_WAITING_ROOM_REQUEST';

export const GET_WAITING_ROOM_SESSION_POSITION_PATH = '/api/get-session-position';
export const GET_WAITING_ROOM_SESSION_POSITION_REQUEST_NAME = 'GET_WAITING_ROOM_SESSION_POSITION_REQUEST';

export const GET_WAITING_ROOM_CHART_PATH = '/api/get-waiting-room-chart';
export const GET_WAITING_ROOM_CHART_REQUEST_NAME = 'GET_WAITING_ROOM_CHART_REQUEST';

export const GET_WAITING_ROOM_STATS_PATH = '/api/get-waiting-room-stats';

export const GET_RETURN_INFO_PATH = '/api/get-return-info';
export const START_IN_QUEUE_PATH = '/api/start';
export const ADD_AGAIN_IN_WAITING_ROOM_PATH = '/api/add-again-in-waiting-room';

export const SESSION_EXPIRED_VALUE = -1;
export const SESSION_PROCESSED_VALUE = 0;

export const WAITING_ROOM_STOPPED_STATUS = 'stopped';
export const WAITING_ROOM_RUNNING_STATUS = 'running';
